export default __webpack_public_path__ + "static/media/notfound.dff11837.gif";